import {Table} from "antd";
import moment from "moment";
import React from "react";
import {DateLabel, ShiftEndHour, ShiftStartHour} from "./DailyPoolSlotTable.styles";
import {SlotUpdatePopConfirm} from "../slotUpdatePopConfirm/SlotUpdatePopConfirm";
import {SlotCell} from "../slotCell/SlotCell";

export const DailyPoolSlotTable = ({
    poolId,
    tableData = [],
    slotsData = [],
    loading,
    pagination,
    recall = () => {}
}) => {
    const currentPage = 1;
    const totalPage = 100;

    const handleChangePage = async page => {
        console.log(page);
    };

    const findInSlotsData = ({date, shiftHourId}) => {
        const slot = slotsData.find(
            slot =>
                slot.date === date && slot?.shiftHour?._id.toString() === shiftHourId?.toString()
        );
        return slot;
    };

    const generateColumnsByShiftHours = () => {
        const columns = [];
        if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
            return columns;
        }

        const shiftHours = tableData?.[0]?.shiftHours || [];
        const shiftHourColumnPrefix = "shiftHours";
        shiftHours.forEach(shiftHour => {
            columns.push({
                title: () => (
                    <>
                        <ShiftStartHour>{shiftHour?.startTime}</ShiftStartHour>
                        <ShiftEndHour>{shiftHour?.endTime}</ShiftEndHour>
                    </>
                ),
                dataIndex: `${shiftHourColumnPrefix}_${shiftHour._id}`,
                key: `${shiftHourColumnPrefix}_${shiftHour._id}`,
                align: "center",
                width: 70,
                render: (text, record) => {
                    const slot = findInSlotsData({
                        date: record.date,
                        shiftHourId: shiftHour._id
                    });
                    if (!slot) {
                        return <SlotCell disabled={true}>{""}</SlotCell>;
                    }
                    return (
                        <SlotUpdatePopConfirm
                            poolId={poolId}
                            dailySlotId={slot?._id}
                            limit={slot?.limit || 0}
                            minLimit={slot?.totalBooked || 0}
                            recall={recall}
                        >
                            <div>
                                <SlotCell limit={slot?.limit} totalBooked={slot?.totalBooked} />
                            </div>
                        </SlotUpdatePopConfirm>
                    );
                }
            });
        });
        return columns;
    };

    return (
        <>
            <Table
                rowKey="date"
                loading={loading}
                size="small"
                style={{width: "100%", fontSize: "10px !important"}}
                pagination={
                    !pagination
                        ? false
                        : {
                              total: totalPage,
                              current: currentPage,
                              onChange: handleChangePage,
                              hideOnSinglePage: true,
                              showSizeChanger: false
                          }
                }
                tableLayout="fixed"
                dataSource={tableData}
                scroll={{x: 1200}}
                bordered
                columns={[
                    {
                        title: "Tarih",
                        dataIndex: "date",
                        key: "date",
                        align: "center",
                        fixed: "left",
                        width: 150,
                        render: date => (
                            <DateLabel>{date ? moment(date).format("DD.MM.YYYY") : "-"}</DateLabel>
                        )
                    },
                    ...generateColumnsByShiftHours()
                ]}
            />
        </>
    );
};
